import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-computadoras',
    templateUrl: './computadoras.component.html',
    styleUrls: ['./computadoras.component.css'],
    standalone: false
})
export class ComputadorasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
